import Handlebars from 'handlebars';
import $ from 'jquery';

function render(parameters){
  var context = parameters;
  $('#view .view__hbs').empty();
  $('#view .view__hbs').append(Handlebars.templates.StoreTemplate(context));
}

export default {
  render
};
